<script>
    import { auth } from '../../../firebase';

    export let type = 'privateProfile'; // privateProfile, publicProfile, chatcards
    export let title = 'Your Profile';
</script>
<style lang="scss" src="./Topbar.scss"></style>

<div class="topbar">
    <header class="topbar__header">
        {#if type === 'privateProfile'}
            <span class="topbar__title">{title}</span>
            <button class="topbar__logout btn btn--tertiary" on:click={ () => auth.signOut() }>Logout</button>
        {:else if type === 'publicProfile'}
            <!-- TODO -->
        {:else if type === 'chatCards'}
            <span class="topbar__title">{title}</span>
        {/if}
    </header>
</div>